new class {
    constructor() {
        this.animatedElements = new Set();
        this.init();
    }

    init() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.setupAnimations());
        } else {
            this.setupAnimations();
        }
    }

    setupAnimations() {
        const animateElements = document.querySelectorAll('.banner-with-numbers__item-number-animate');

        if (animateElements.length === 0) return;

        if ('IntersectionObserver' in window) {
            this.setupIntersectionObserver(animateElements);
        } else {
            animateElements.forEach(element => this.animateNumber(element));
        }
    }

    setupIntersectionObserver(elements) {
        const options = {
            threshold: 0.3,
            rootMargin: '0px 0px -50px 0px',
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && !this.animatedElements.has(entry.target)) {
                    this.animateNumber(entry.target);
                    this.animatedElements.add(entry.target);
                }
            });
        }, options);

        elements.forEach(element => observer.observe(element));
    }

    animateNumber(element) {
        const finalValue = this.extractNumber(element.textContent);

        if (finalValue === null) return;

        const duration = this.calculateDuration(finalValue);
        const decimalPlaces = this.getDecimalPlaces(finalValue);
        const startTime = performance.now();

        const originalText = element.textContent;
        const numberMatch = originalText.match(/[\d,]*\.?\d+/);
        const numberStart = originalText.indexOf(numberMatch[0]);
        const prefix = originalText.substring(0, numberStart);
        const suffix = originalText.substring(numberStart + numberMatch[0].length);

        const animate = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);

            const easedProgress = 1 - Math.pow(1 - progress, 4);
            const currentValue = finalValue * easedProgress;

            const displayValue = decimalPlaces > 0
                ? currentValue.toFixed(decimalPlaces)
                : Math.floor(currentValue).toString();

            const formattedValue = this.addCommas(displayValue, originalText.includes(','));

            element.textContent = prefix + formattedValue + suffix;

            if (progress < 1) {
                requestAnimationFrame(animate);
            } else {
                element.textContent = originalText;
            }
        };

        requestAnimationFrame(animate);
    }

    extractNumber(text) {
        const matches = text.match(/[\d,]*\.?\d+/);
        if (!matches) return null;

        const cleanNumber = matches[0].replace(/,/g, '');
        const number = parseFloat(cleanNumber);

        return isNaN(number) ? null : number;
    }

    calculateDuration(value) {
        if (value <= 10) return 1000;
        if (value <= 100) return 1500;
        if (value <= 1000) return 2000;
        return 2500;
    }

    getDecimalPlaces(number) {
        const str = number.toString();
        if (str.indexOf('.') !== -1) {
            return str.split('.')[1].length;
        }
        return 0;
    }

    addCommas(numberStr, shouldAddCommas) {
        if (!shouldAddCommas) return numberStr;

        const parts = numberStr.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return parts.join('.');
    }

    triggerAnimation(selector = '.banner-with-numbers__item-number-animate') {
        const elements = document.querySelectorAll(selector);
        elements.forEach(element => {
            if (!this.animatedElements.has(element)) {
                this.animateNumber(element);
                this.animatedElements.add(element);
            }
        });
    }

    resetAnimations() {
        this.animatedElements.clear();
        const elements = document.querySelectorAll('.banner-with-numbers__item-number-animate');
        elements.forEach(element => {
            element.style.opacity = '';
        });
    }
}
